import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { TextButton, StyledIcon, token, List, ListItem, IconChevronDown, Anchor } from '@zillow/constellation';
import { yieldCallback } from '@zillow/yield-callback';
import PropTypes from 'prop-types';
import styled from 'styled-components';

var SEOFooterSubmenuHeader = /*#__PURE__*/styled(TextButton).withConfig({
  componentId: "sc-kyc3ft-0"
})(["padding:12px 16px;", "{color:", ";width:16px;height:16px;margin-left:", ";}"], StyledIcon, token('colors.brand'), token('spacing.md'));
var SEOFooterSubmenuList = /*#__PURE__*/styled(List).withConfig({
  componentId: "sc-kyc3ft-1"
})(["margin-top:0;margin-bottom:0;"]);
var SEOFooterSubmenuListItem = /*#__PURE__*/styled(ListItem).withConfig({
  componentId: "sc-kyc3ft-2"
})(["margin-top:0;margin-bottom:0;"]);
var SEOFooterSubmenu = function SEOFooterSubmenu(_ref) {
  var label = _ref.label,
    links = _ref.links;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SEOFooterSubmenuHeader, {
    buttonType: "secondary",
    fontType: "bodyHeading",
    icon: /*#__PURE__*/React.createElement(IconChevronDown, {
      size: "xs"
    }),
    iconPosition: "end",
    onClick: yieldCallback(function () {
      return setIsOpen(!isOpen);
    })
  }, label), isOpen && /*#__PURE__*/React.createElement(SEOFooterSubmenuList, {
    appearance: "none"
  }, links.map(function (link) {
    return /*#__PURE__*/React.createElement(SEOFooterSubmenuListItem, {
      key: link === null || link === void 0 ? void 0 : link.label
    }, /*#__PURE__*/React.createElement(Anchor, {
      href: link.src,
      target: link.target
    }, link.label));
  })));
};
SEOFooterSubmenu.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    src: PropTypes.string,
    target: PropTypes.string
  })).isRequired
} : {};

/** @component */
var SEOFooterSubmenu$1 = SEOFooterSubmenu;

export { SEOFooterSubmenuHeader, SEOFooterSubmenuList, SEOFooterSubmenuListItem, SEOFooterSubmenu$1 as default };
